export const setWithExpiry = (key, value, ttl) => {
    const now = new Date()

    const item = {
        value: value,
        expiry: now.getTime() + ttl
    }
    localStorage.setItem(key, JSON.stringify(item))
    localStorage.setItem('@oee-monitor/expiry', JSON.stringify(item.expiry))
}

export const setCheckValue = (data,callback) => {
  const boolVal = (/true/i).test(data.target.value)
    
  const forms = document.querySelectorAll("form");
  const form = forms[0];

  Array.from(form.elements).forEach((element) => {
    if (element.type === "checkbox" && data.target.name !== "all_days" && element.name !== data.target.name) {
      if (!boolVal)
        if(element.name == "all_days"){
          element.disabled = false
        }else{
          element.disabled = true
        }
      else
        element.disabled = false
    }
  });
  callback(!boolVal)
}

export const  getWithExpiry = (key) => {
    const itemStr = localStorage.getItem(key)

    if (!itemStr) {
        return null
    }

    const item = parseInt(itemStr)

    const now = new Date()

    if (now.getTime() > item) {
        localStorage.removeItem('@oee-monitor/token')
        return null
    }
    return item.value
}

export function SortByProperty(property){  
    return function(a,b){  
       if(a[property] > b[property])  
          return 1;  
       else if(a[property] < b[property])  
          return -1;  
       return 0;  
    }  
 }


 export const  handleColor = (v) => {
    const lg1 = document.getElementById("lg1");
    const lg2 = document.getElementById("lg2");
    const lg3 = document.getElementById("lg3");
    const lg4 = document.getElementById("lg4");
    const lg5 = document.getElementById("lg5");
    if (lg1 && lg2 && lg3 && lg4 && lg5 ) {
      if (v.currentTarget.id === "lg1") {
        lg1.style.backgroundColor = "#05ca83";
        lg1.style.color = "#fff";
        lg2.style.backgroundColor = "#fff";
        lg2.style.color = "#495057";
        lg3.style.backgroundColor = "#fff";
        lg3.style.color = "#495057";
        lg4.style.backgroundColor = "#fff";
        lg4.style.color = "#495057";
        lg5.style.backgroundColor = "#fff";
        lg5.style.color = "#495057";
      } else if (v.currentTarget.id === "lg2") {
        lg1.style.backgroundColor = "#fff";
        lg1.style.color = "#495057";
        lg2.style.backgroundColor = "#05ca83";
        lg2.style.color = "#fff";
        lg3.style.backgroundColor = "#fff";
        lg3.style.color = "#495057";
        lg4.style.backgroundColor = "#fff";
        lg4.style.color = "#495057";
        lg5.style.backgroundColor = "#fff";
        lg5.style.color = "#495057";
      } else if (v.currentTarget.id === "lg3") {
        lg1.style.backgroundColor = "#fff";
        lg1.style.color = "#495057";
        lg2.style.backgroundColor = "#fff";
        lg2.style.color = "#495057";
        lg3.style.backgroundColor = "#05ca83";
        lg3.style.color = "#fff";
        lg4.style.backgroundColor = "#fff";
        lg4.style.color = "#495057";
        lg5.style.backgroundColor = "#fff";
        lg5.style.color = "#495057";
      } else if (v.currentTarget.id === "lg4") {
        lg1.style.backgroundColor = "#fff";
        lg1.style.color = "#495057";
        lg2.style.backgroundColor = "#fff";
        lg2.style.color = "#495057";
        lg3.style.backgroundColor = "#fff";
        lg3.style.color = "#495057";
        lg4.style.backgroundColor = "#05ca83";
        lg4.style.color = "#fff";
        lg5.style.backgroundColor = "#fff";
        lg5.style.color = "#495057";
      } else if (v.currentTarget.id === "lg5") {
        lg1.style.backgroundColor = "#fff";
        lg1.style.color = "#495057";
        lg2.style.backgroundColor = "#fff";
        lg2.style.color = "#495057";
        lg3.style.backgroundColor = "#fff";
        lg3.style.color = "#495057";
        lg4.style.backgroundColor = "#fff";
        lg4.style.color = "#495057";
        lg5.style.backgroundColor = "#05ca83";
        lg5.style.color = "#fff";
      }
    }
  };


  